import { useEffect } from "react";
import { Box, Text } from "@mantine/core";
import { track } from "./analytics/analytics";

export default function SimpleStepper({ step, marginTop }) {
  const total = 4;

  const bars = [];
  for (let i = 0; i < total; i++) {
    const stepNum = i + 1;
    const filled = stepNum <= step;

    bars.push(
      <Box
        key={stepNum}
        style={(theme) => ({
          flex: 1,
          background: filled ? theme.colors[theme.primaryColor][6] : "#e0e0e0",
          transition: "background 200ms ease",
          marginRight: i === total - 1 ? 0 : 4,
        })}
      />,
    );
  }

  useEffect(() => {
    track("Step Viewed", { step });
  }, [step]);

  return (
    <Box style={{ width: "100%", marginTop: marginTop }}>
      <Text weight={600} size="sm" mb="xs">
        Step {step} of {total}
      </Text>

      <Box style={{ display: "flex", width: "100%", height: 8 }}>{bars}</Box>
    </Box>
  );
}
